import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["className", "children", "tabIndex"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { twMerge } from 'tailwind-merge';
import React, { forwardRef } from 'react';
import { useRowTabIndex } from './row-tab-stop';
import { jsx as _jsx } from "react/jsx-runtime";
// `focus-ring` (tailwind.plugin.css) is the keyboard focus indicator for
// every button built on this one. In a list row that does not hold the
// list's Tab stop, the button is out of the Tab order. The ref reaches the
// <button>, for a caller that moves focus to it.
var BaseButton = /*#__PURE__*/forwardRef(function BaseButton(_ref, ref) {
  var className = _ref.className,
    children = _ref.children,
    tabIndex = _ref.tabIndex,
    props = _objectWithoutProperties(_ref, _excluded);
  var rowTabIndex = useRowTabIndex();
  return /*#__PURE__*/_jsx("button", _objectSpread(_objectSpread({
    ref: ref,
    className: twMerge('focus-ring flex items-center justify-center rounded-sm p-1 disabled:bg-gray-300 disabled:text-gray-500', className),
    tabIndex: rowTabIndex !== null && rowTabIndex !== void 0 ? rowTabIndex : tabIndex
  }, props), {}, {
    children: children
  }));
});
export default BaseButton;